import {
    Modal,
    Form,
    Card,
    Row,
    Col,
    Button,
    ButtonGroup,
    ToggleButton
} from "react-bootstrap";
import React, { useState} from "react";
import {treatments_list} from '../../../lists/treatments-list';
import { useForm } from "react-hook-form";
import PhoneInput from 'react-phone-input-2'


export default function PatientInfoModal(props) {

    // const clinic = props.clinicData;
    const [radioValue, setRadioValue] = useState('1');
    const [phone, setPhone] = useState();
    const handleClose = () => props.setShow(false);

    const {register, handleSubmit} = useForm();

    const onSubmit = (data) => {
        data.phone = phone;
        data.time = props.bookingTime;
        data.dentist = props.dentist;
        const treatment = JSON.parse(data.treatment)
        const value = treatment.value;
        const label = treatment.label;
        data.price = props.prices[value];
        data.treatment = label;
        console.log(data);

        props.setBookingData(data);
        props.setShowNextModal(true);
        handleClose();
    }

        return (
          <Modal show={true} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title >Patient Info</Modal.Title>
            </Modal.Header>
            <Modal.Body className='mx-3'>
                <h6>Who's the lucky person visiting an UAE Dentist?</h6>
                <Card text='light' bg='secondary' className="text-center py-3 px-3 my-3">
                    Please ensure all fields are typed exactly as listed on your insurance plan.
                </Card>

                <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row xs={2} md={2} lg={2}>
                            <Col>
                            <Form.Group >
                                <Form.Control required placeholder="First Name" name="first_name" size="lg" ref={register ({required:true})}/>
                            </Form.Group>
                            </Col>
                            <Col>
                            <Form.Group >
                                <Form.Control required placeholder="Last Name" name="last_name" size="lg" ref={register ({required:true})}/>
                            </Form.Group>
                            </Col>
                            </Row>
                            <Form.Group>
                                <Form.Control required size="lg" name="email" ref={register ({required:true})} placeholder="Email" />
                            </Form.Group>
                            <Form.Group controlId="phone">
                            <Form.Label>Phone Number</Form.Label>
                                <PhoneInput 
                                    required
                                    className='w-100'
                                    // localization={ae}
                                    country={'ae'}
                                    placeholder="Please provide your phone number" 
                                    value={phone}
                                    onChange={input => setPhone( input )}
                                />
                            </Form.Group>

                            <Form.Group controlId="services">
                                <Form.Label className='font-weight-bold'>Treatment</Form.Label>
                                <Form.Control size="lg" as="select"  name="treatment" ref={register ({required:true})} custom>
                                    {treatments_list.map((treatment, idx) => (
                                        <option value={JSON.stringify(treatment)}key={idx}>{treatment.label}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>

                            <p className='my-3'>Are you the primary member / subscriber on your dental insurance plan?</p>
                            <Row xs={2} md={2} lg={2}>
                                <ButtonGroup toggle className='mx-auto my-3'>
                                        <ToggleButton
                                            className='mx-0 h5'
                                            variant='secondary'
                                            type="radio"
                                            name="answer_yes"
                                            value={1}
                                            checked={radioValue === 1}
                                            onChange={(e) => setRadioValue(e.currentTarget.value)}
                                            size='lg'
                                        >
                                            Yes
                                        </ToggleButton>
                                        <ToggleButton
                                            variant='secondary'
                                            className='mx-0 h5'
                                            type="radio"
                                            name="answer_no"
                                            value={2}
                                            checked={radioValue === 2}
                                            onChange={(e) => setRadioValue(e.currentTarget.value)}
                                            size='lg'
                                        >
                                            No
                                        </ToggleButton>
                                </ButtonGroup>
                            </Row>

                            <Button className='rounded-pill h5' variant="primary" type="submit" size='lg' block>
                                Review
                            </Button>
                        </Form>
            </Modal.Body>
          </Modal>  
        );
      }
    